<template>
  <div class="box">
    <img
      src="@assets/images/bear.png"
    >
    抱歉，出错了，请您稍后再试！
  </div>
</template>

<script type="text/babel">
export default {
  name: 'NotFound',
}
</script>

<style lang="less" scoped>
.box{position: absolute; top:50%; left:50%; margin:-190px 0 0 -150px;  text-align: center; font-size: 18px; font-weight: bold;
img{display:block; width:300px; margin:0 auto 20px;}
}
</style>
